import Footer from '../components/layout/footer';

export default function DocumentaryPage() {
  return (
    <div className="min-h-screen bg-neutral-950 text-white">
      <header className="pt-24 md:pt-32 pb-12 md:pb-16 px-6 text-center border-b border-white/5">
        <p className="font-['Sora'] text-xs tracking-[0.35em] text-white/40 uppercase mb-3">
          Maison Adji
        </p>
        <h1 className="font-['Sora'] text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white">
          Documentary
        </h1>
        <p className="mt-4 font-['Rubik'] text-white/60 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
          L’univers Maison Adji en images.
        </p>
      </header>

      <div className="max-w-2xl mx-auto px-6 py-12 md:py-16">
        <p className="font-['Rubik'] text-white/70 leading-relaxed">
          Contenu à venir.
        </p>
      </div>
      <Footer />
    </div>
  );
}
